module.exports = __webpack_public_path__ + "img/estacionamiento.df990c28.svg";